module.exports = __webpack_public_path__ + "img/autokast.286cac46.jpg";